import { ProfileData } from "../../common/common.model";
import { getAvailableRoles } from "../../modules/Admin/admin.service";
import { fetchProfileData } from "../../services/auth.service";

export const USER_INFO_ACTIONS = {
  SET_USER_PROFILE_DATA: "SET_USER_PROFILE_DATA",
  SET_AVAILABLE_ROLES: "SET_AVAIALBLE_ROLES",
};

export const fetchAvailableRoles = () => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: USER_INFO_ACTIONS.SET_AVAILABLE_ROLES,
        payload: {
          loading: true,
          error: {},
        },
      });

      const res = await getAvailableRoles();

      dispatch({
        type: USER_INFO_ACTIONS.SET_AVAILABLE_ROLES,
        payload: {
          loading: false,
          error: {},
          data: res,
        },
      });
    } catch (err) {}
  };
};

export const fetchProfileDataThunk = () => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: USER_INFO_ACTIONS.SET_USER_PROFILE_DATA,
        payload: {
          loading: true,
          error: undefined,
        },
      });
      const response = await fetchProfileData();
      const data = new ProfileData(response);
      dispatch({
        type: USER_INFO_ACTIONS.SET_USER_PROFILE_DATA,
        payload: {
          loading: false,
          data: data,
          // Explicitly clear any stale error from a previous failed cycle —
          // the reducer does a shallow merge, so without this a past error
          // would linger in state forever even after a successful fetch.
          error: undefined,
        },
      });
    } catch (error) {
      dispatch({
        type: USER_INFO_ACTIONS.SET_USER_PROFILE_DATA,
        payload: {
          loading: false,
          error: error,
        },
      });
    }
  };
};
